import { render, staticRenderFns } from "./sme-kyc-form.vue?vue&type=template&id=4487a5b2&scoped=true&"
import script from "./sme-kyc-form.vue?vue&type=script&lang=js&"
export * from "./sme-kyc-form.vue?vue&type=script&lang=js&"
import style0 from "./sme-kyc-form.vue?vue&type=style&index=0&id=4487a5b2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4487a5b2",
  null
  
)

export default component.exports